module.exports = __webpack_public_path__ + "img/arrow-square-down-left.f0ce7adb.svg";